import { Component, Injector, OnInit } from '@angular/core';
import 'rxjs/add/operator/finally';
import { ActiveModal } from '../../../../../modals/classes/active-modal';
import { ChassisFormHandler } from '../../../../../forms/form/classes/form-handler';
import { Model } from '../../../../../api/model';
import { MODAL_ACTION } from '../../../../../modals/modal-action';

@Component({
    selector: 'chassis-core-tenant-user-create-modal',
    templateUrl: 'list-plugin.modal.html',
    styleUrls: ['list-plugin.modal.scss']
})
export class ListPluginModal implements OnInit {

    /**
     * The Loading instance.
     *
     * @type {any}
     */
    public loading: any;

    /**
     * The ChassisFormHandler instance.
     *
     * @type {ChassisFormHandler}
     */
    public form: ChassisFormHandler;

    /**
     * The object to validate.
     */
    public data: any = {};

    constructor(protected injector: Injector, protected modal: ActiveModal) {
    }

    ngOnInit() {
        this.loading = this.modal.get('loading');

        this.createForm();
        this.setModalButtons();
    }

    private createForm(): void {
        const model: Model = this.modal.get('model');
        this.data          = Object.assign({}, model);

        this.form       = this.modal.get('form');
        this.form.model = this.data;

        this.form.notifications = false;

        this.form.processor((data, resolve) => {
            resolve(data);
        });

        const action: MODAL_ACTION = this.modal.get('action');

        this.form.success(() => {
            return new Promise((resolve) => {
                const data = (action === MODAL_ACTION.ADD && this.data.model) ? this.data.model : this.data;

                this.modal.close({
                    action: action,
                    data: data
                });

                resolve();
            });
        });

        this.form.error(() => {
            this.loading.stop();
        });
    }

    protected setModalButtons() {
        const buttons = this.modal.get<Map<string, any>>('buttons');

        this.setSubmitModalButton(buttons);
    }

    protected setSubmitModalButton(buttons: Map<string, any>) {
        const ok = buttons.get('ok');

        ok.callback = () => {
            this.loading.start();
            this.form.submit();
        };

        ok.loader = () => {
            return this.loading.isLoading();
        };
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-plugin-modal/list-plugin.modal.ts